import { localStore } from './useLocalStore';
import DefaultEnv from '../config/env';
export const getEndpoints = ()=>{
    try {
        const store = localStore.getState();

        const env = store?.endpoints;

        if (env) {
            return env;
        } else {
            return DefaultEnv.endpoints
        }
    } catch (e) {
        return DefaultEnv.endpoints
    }
}

export const getAppid = () => {
    try {
        const store = localStore.getState();
        const appid = store?.appid;
        if (appid) {
            return appid;
        } else {
            return '';
        }
    } catch (e) {
        return '';
    }
}

export const getLocale = () => {
    try {
        const store = localStore.getState();
        const locale = store?.locale;
        if (locale) {
            return locale;
        } else {
            return 'en';
        }
    } catch (e) {
        return 'en';
    }
}
export const getToken = () => {
    try {
        const store = localStore.getState();
        const token = store?.token;
        if (token) {
            return token;
        } else {
            return '';
        }
    } catch (e) {
        return '';
    }
}